import pluck from '../utilities/pluck';

const selectSearchTerm = pluck('searchTerm');

export default selectSearchTerm;
